<template>
  <g fill-rule="evenodd">
    <path d="M3.2 19.2H16a3.2 3.2 0 003.2-3.2V3.2A3.2 3.2 0 0016 0H3.2A3.2 3.2 0 000 3.2V16a3.2 3.2 0 003.2 3.2z" />
    <path
      d="M1.6 3.2c0-.88.72-1.6 1.6-1.6H16c.88 0 1.6.72 1.6 1.6v3.2h-16V3.2zM16 17.6H3.2A1.6 1.6 0 011.6 16V8h16v8c0 .88-.72 1.6-1.6 1.6z"
      class="secondary-color"
    />
    <path
      d="M4 3.2a.8.8 0 110 1.6.8.8 0 010-1.6M7.2 3.2a.8.8 0 110 1.6.8.8 0 010-1.6M10.4 3.2a.8.8 0 110 1.6.8.8 0 010-1.6M12.57 9.83a.8.8 0 10-1.14 1.14l1.84 1.83-1.84 1.83a.8.8 0 001.14 1.14l2.4-2.4a.8.8 0 000-1.14l-2.4-2.4zM7.77 9.83a.8.8 0 00-1.14 0l-2.4 2.4a.8.8 0 000 1.14l2.4 2.4a.8.8 0 001.14-1.14L5.93 12.8l1.84-1.83a.8.8 0 000-1.14"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CheckIcon",
});
</script>
